module.exports = __webpack_public_path__ + "img/tengbang.b79fd1c3.jpg";